import Vue from "vue";
import Router from "vue-router";
import DashboardLayout from "@/views/Layout/DashboardLayout";
import AuthBasicLayout from "@/views/Layout/AuthBasicLayout";
import UserDetail from "@/views/Pages/Profile/UserDetail.vue";
import StudentDetail from "@/views/Pages/Students/StudentDetail.vue";
import OnlineVideos from "@/views/Pages/Works/OnlineVideos.vue";
import SchoolRegistration from "@/views/SchoolAdmins/SchoolRegistration.vue";
import libraryRoute from "@/library/routes.js";

const Dashboard = () => import("@/views/Dashboard/Dashboard.vue");
const PageLesson = () => import("@/views/Dashboard/PageLesson.vue");
const PageLessonESIS = () => import("@/views/Dashboard/PageLessonESIS.vue");

const PageLessonPreview = () =>
  import("@/views/Dashboard/PageLessonPreview.vue");

const Login = () =>
  import(
    /* webpackChunkName: "pages" */
    "@/views/Pages/Authentication/SignUp/Basic.vue"
  );

const Employees = () =>
  import(
    /* webpackChunkName: "pages" */
    "@/views/Pages/Profile/Employees.vue"
  );

const Students = () =>
  import(
    /* webpackChunkName: "pages" */
    "@/views/Pages/Profile/Students.vue"
  );
const PageRequests = () =>
  import(
    /* webpackChunkName: "pages" */
    "@/sms/excuses/PageRequests.vue"
  );
const PageDaalgavar = () =>
  import(
    /* webpackChunkName: "pages" */
    "@/views/Dashboard/Widgets/TopicDaalgavarTable.vue"
  );
//myclass
// const MyClassStudents = () =>
//   import("@/views/Pages/MyClass/MyClassStudents.vue");
const MyNClassesUnelgee2 = () =>
  import("@/views/Pages/MyClass/MyNClassesUnelgee2.vue");

const MyNClassesLessonsSongolt = () =>
  import("@/views/Pages/MyClass/MyNClassesLessonsSongolt.vue");

const MyNClassesCalendars = () =>
  import("@/views/Pages/MyClass/MyNClassesCalendars.vue");

const PageSorilAssignmentsByGrandit = () =>
  import("@/views/Pages/Assignments/PageSorilAssignmentsByGrandit.vue");
const StudentsSorils = () =>
  import("@/views/Pages/Students/StudentsSorils.vue");

//for students

const StudentLessonDetail = () =>
  import("@/views/Pages/Students/StudentLessonDetail.vue");
const StudentSelectLessons = () =>
  import("@/views/Pages/Students/StudentSelectLessons.vue");
const StudentShowAssignmentResults = () =>
  import("@/views/Pages/Students/StudentShowAssignmentResults.vue");

const StudentShowAssignmentAllResults = () =>
  import("@/views/Pages/Assignments/XShowAssignmentAllResults.vue");
const StudentShowAssignmentAllResultsDetail = () =>
  import("@/views/Pages/Assignments/XShowAssignmentAllResultsDetails.vue");
const PublicStudentsScore = () =>
  import("@/views/Pages/Assignments/PublicStudentsScore.vue");
//Analyzing....

const AllQuestionsAnalysis = () =>
  import("@/views/Pages/Analyzes/AllQuestionsAnalysis.vue");
const ReportSchool = () => import("@/views/Pages/Analyzes/ReportSchool.vue");

const PageXEelj = () =>
  import(
    /* webpackChunkName: "pages" */
    "@/views/Pages/Profile/PageXEelj.vue"
  );

Vue.use(Router);
let OrganizationSetting = {
  path: "/pages",
  component: DashboardLayout,
  name: "OrganizationSetting",
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "/chat",
      name: "ChatPage",
      component: () => import("@/chat/ChatPage.vue"),
      props: true,
      meta: { groupName: "Pages" },
    },
    {
      path: "/appmonitor",
      name: "AppUsageMonitor",
      component: () => import("@/bs/admins/AppUsageMonitor.vue"),
      props: true,
      meta: { groupName: "Pages" },
    },
    {
      path: "/training112monitor",
      name: "Training112Monitor",
      component: () => import("@/bs/admins/Training112Monitor.vue"),
      meta: { groupName: "Pages" },
    },
    {
      path: "/appmenus",
      name: "AppMenus",
      component: () => import("@/bs/appmenus/AppGroups.vue"),
      meta: { groupName: "Pages" },
    },
    {
      path: "/monitoringbg",
      name: "ZahiralExecutionMonitor",
      component: () =>
        import("@/bs/monitoringLessons/ZahiralExecutionMonitor.vue"),
      props: true,
      meta: { groupName: "Pages" },
    },
    {
      path: "/accessrequests",
      name: "AccessRequests",
      component: () => import("@/bs/AccessRequests.vue"),
      props: true,
      meta: { groupName: "Pages" },
    },
    {
      path: "/parentphonefill",
      name: "ParentPhoneFill",
      component: () => import("@/bs/ParentPhoneFill.vue"),
      props: true,
      meta: { groupName: "Pages" },
    },
    {
      path: "/stafflogins",
      name: "StaffLoginOverview",
      component: () => import("@/bs/admins/StaffLoginOverview.vue"),
      props: true,
      meta: { groupName: "Pages" },
    },
    {
      path: "/nationalchats",
      name: "NationalChatRooms",
      component: () => import("@/bs/admins/NationalChatRooms.vue"),
      props: true,
      meta: {
        groupName: "Pages",
        requiresAuth: true,
        allowedRoles: ["superadmin", "superadmin2"],
      },
    },
    {
      path: "/schoolaccounts",
      name: "SchoolAccountsMonitor",
      component: () => import("@/bs/admins/SchoolAccountsMonitor.vue"),
      props: true,
      meta: { groupName: "Pages" },
    },
    {
      path: "/busattendance",
      name: "BusAttendance",
      component: () => import("@/bus/BusAttendance.vue"),
      meta: { groupName: "Pages" },
    },
    {
      path: "/userdetail/:userrefid",
      name: "UserDetail",
      component: UserDetail,
      props: true,
      meta: {
        requiresAuth: false,
        groupName: "Pages",
      },
    },

    {
      path: "/studentdetail/:userrefid",
      name: "StudentDetail",
      component: StudentDetail,
      props: true,
      meta: {
        requiresAuth: false,
        groupName: "Pages",
      },
    },
    {
      path: "/onlinevideos",
      name: "OnlineVideos",
      component: OnlineVideos,
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/tutorialvideos",
      name: "TutorialVideos",
      component: () => import("@/views/Pages/Works/TutorialVideos.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },

    {
      path: "/studentadditionalstats",
      name: "StudentAdditionalStats",
      component: () => import("@/bs/StudentAdditionalStats.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/suuhutulburstats",
      name: "SuuHutulburStats",
      component: () => import("@/bs/SuuHutulburStats.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/managerinlessondiagnostics",
      name: "ManagerInLessonDiagnostics",
      component: () => import("@/bs/ManagerInLessonDiagnostics.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/attendancestats",
      name: "AttendanceStats",
      component: () => import("@/bs/AttendanceStats.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/grandittodos",
      name: "GranditTodos",
      component: () => import("@/bs/admins/GranditTodos.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/shops",
      name: "Shops",
      component: () => import("@/bs/additionals/Shops.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/personaldevelopments",
      name: "PersonalDevelopments",
      component: () => import("@/bs/additionals/PersonalDevelopments.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/learningmaterials",
      name: "learningmaterials",
      component: () => import("@/bs/Learningmaterials.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/learningmaterials2",
      name: "learningmaterials2",
      component: () => import("@/bs/Learningmaterials2.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/learningmaterials3",
      name: "learningmaterials3",
      component: () => import("@/bs/Learningmaterials3.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/pdfsplitting",
      name: "pdfsplitting",
      component: () => import("@/bs/PdfSplitting.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/pdfsplitting2",
      name: "pdfsplitting2",
      component: () => import("@/bs/PdfSplitting2.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/guizetgeliinunelgee",
      name: "guizetgeliinunelgee",
      component: () => import("@/bs/GuizetgeliinUnelgee.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/booklibrary",
      name: "booklibrary",
      component: () => import("@/bs/BookLibrary.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/screenrecording",
      name: "ScreenRecording",
      component: () => import("@/bs/ScreenRecording.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/publiclearning",
      name: "PublicLearning",
      component: () => import("@/bs/PublicLearning.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/pdfbooksextraction",
      name: "PdfBooksExtraction",
      component: () => import("@/bs/prototypes/PdfBooksExtraction.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/eyeshdashboard",
      name: "EyeshDashboard",
      component: () => import("@/bs/prototypes/EyeshDashboard.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/medlesongolt",
      name: "MedleSongolt",
      component: () => import("@/26/MedleSongolt.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/CalendarButez",
      name: "CalendarButez",
      component: () => import("@/26/CalendarButez.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    }, //do not delete
    {
      path: "/register2026",
      name: "register2026",
      component: () => import("@/26/register2026.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    }, //do not delete
    {
      path: "/schoolcalendarButez",
      name: "SchoolCalendarButez",
      component: () => import("@/26/SchoolCalendarButez.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    }, //do not delete
    {
      path: "/Burtgel",
      name: "Burtgel",
      component: () => import("@/bs/Burtgel.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/myclass/MyNClasses25",
      name: "MyNClasses25",
      component: () => import("@/bs/MyClass/MyNClasses25.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/myclass/MyNClassesStudents",
      name: "MyNClassesStudents",
      component: () => import("@/bs/MyClass/MyNClassesStudents.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },

    {
      path: "/pages/teacherhomework",
      name: "TeacherHomework",
      component: () => import("@/homework/pages/homework_teacher.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/bagshiinJurnal",
      name: "bagshiinJurnal",
      component: () => import("@/bs/MyClass/BagshiinJurnal.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },

    {
      path: "/newyearmonitoring25",
      name: "newyearmonitoring25",
      component: () => import("@/bs/newyearmonitoring25.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },

    {
      path: "/pages/pages/teachingplan25",
      name: "TeachingPlan25",
      component: () => import("@/bs/TeachingPlan25.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },

    {
      path: "/pages/pages/classadditionalinfos",
      name: "ClassAdditionalInfos",
      component: () => import("@/bs/MyClass/ClassAdditionalInfos.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },

    {
      path: "/pages/dashboards/attendanceanalysistable25",
      name: "AttendanceAnalysisTable",
      component: () => import("@/bs/irz/AttendanceAnalysisTable25.vue"),
      meta: {
        groupName: "Dashboards",
        requiresAuth: true,
      },
    },
    {
      path: "/pages/dashboards/allattendanceanalysis25",
      name: "AllAttendanceAnalysis",
      // component: () =>
      //   import("@/views/Pages/Irz/AllAttendanceAnalysis.vue"),
      component: () => import("@/bs/irz/AllAttendanceAnalysis25.vue"),
      meta: {
        groupName: "Dashboards",
        requiresAuth: true,
      },
    },

    ///// end of 25, 26
    {
      path: "/schoolregistration",
      name: "SchoolRegistration",
      component: SchoolRegistration,
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/admintraining",
      name: "AdminTraining",
      component: () => import("@/views/SchoolAdmins/AdminTraining.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/qpayburtgel",
      name: "QPayRegistration",
      component: () => import("@/bs/admins/QPayRegistration.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/crmcontroller",
      name: "CRMController",

      component: () => import("@/bs/admins/CRMController.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/cityadmins",
      name: "CityAdmins",
      component: () => import("@/views/City/CityAdmins.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },

    {
      path: "/bagshiinzereg",
      name: "TeacherZereg",
      component: () => import("@/sms/TeacherZereg.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/bagshiinzereg2",
      name: "TeacherZeregPage",
      component: () => import("@/sms/zereg/TeacherZeregPage.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/finalyearreportsOrgs",
      name: "finalyearreportsOrgs",
      component: () => import("@/bs/reports/FinalYearReportsOrgs.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/finalyearreportsorgsadmin",
      name: "FinalYearReportsOrgsAdmin",
      component: () => import("@/bs/reports/FinalYearReportsOrgsAdmin.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/surgaltiinhuvaari",
      name: "SurgaltiinHuvaari",
      component: () => import("@/sms/SurgaltiinHuvaari.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/schoolcrm",
      name: "SchoolCRM",
      component: () => import("@/views/SchoolAdmins/SchoolCRM.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/schoolcrm2",
      name: "SchoolCRM2",
      component: () => import("@/bs/admins/SchoolCRM2.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/schoolexamsplittingdashboard",
      name: "SchoolExamSplittingDashboard",
      component: () => import("@/bs/admins/SchoolExamSplittingDashboard.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/bankinfos",
      name: "BankInfos",
      component: () => import("@/bs/admins/BankInfos.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/schoolemployeeirz",
      name: "SchoolEmployeeIrz",
      component: () => import("@/bs/admins/SchoolEmployeeIrz.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/contractmanagement",
      name: "ContractManagement",
      component: () => import("@/bs/admins/ContractManagement.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/contractschoolview",
      name: "ContractSchoolView",
      component: () => import("@/bs/admins/ContractSchoolView.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/esissystem",
      name: "EsisSystem",
      component: () => import("@/_esis/EsisSystem.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/esismovements",
      name: "EsisMovementTabs",
      component: () => import("@/_esis/EsisMovementTabs.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/esisapitest",
      name: "EsisApiTest",
      component: () => import("@/_esis/EsisApiTest.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
    {
      path: "/surah-bichgiin-turees",
      name: "SurahBichgiinTurees",
      component: () => import("@/bs/rental/SurahBichgiinTurees.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        allowedRoles: [
          "superadmin",
          "superadmin2",
          "schoollibrarer",
          "schooldirector",
          "schoolmanager",
          "teacher",
        ],
        groupName: "Pages",
      },
    },
    {
      path: "/angiin-surah-bichig",
      name: "AngiinSurahBichig",
      component: () => import("@/bs/rental/AngiinSurahBichig.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        allowedRoles: [
          "teacher",
          "superadmin",
          "superadmin2",
          "schoollibrarer",
        ],
        groupName: "Pages",
      },
    },
    {
      path: "/ert-ilruuleg",
      name: "EarlyScreening",
      component: () => import("@/screening/EarlyScreening.vue"),
      props: true,
      meta: {
        requiresAuth: true,
        allowedRoles: ["superadmin", "superadmin2", "schooldoctor"],
        groupName: "Pages",
      },
    },
    {
      path: "/ert-ilruuleg-emchgui",
      name: "ScreeningNoDoctor",
      component: () => import("@/screening/ScreeningNoDoctor.vue"),
      meta: {
        requiresAuth: true,
        groupName: "Pages",
      },
    },
  ],
};
let authBasicPages = {
  path: "/pages",
  component: AuthBasicLayout,
  name: "Authentication Basic",
  children: [
    {
      path: "/pages/authentication/login",
      name: "Login",
      component: Login,
    },
  ],
};

let userPages = {
  path: "/pages",
  component: DashboardLayout,
  name: "Users",
  children: [
    {
      path: "/pages/pages/employees",
      name: "Employees",
      component: Employees,
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/teachers",
      name: "Teachers",
      component: () => import("@/views/Pages/Profile/Teachers.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/students",
      name: "Students",
      component: Students,
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/studentsmedle",
      name: "StudentsMedle",
      component: () => import("@/views/Pages/Profile/StudentsMedle.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/aimagstudentsmedle",
      name: "AimagStudentsMedle",
      component: () => import("@/views/Pages/Profile/AimagStudentsMedle.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/tailanreports",
      name: "TailanReport",
      component: () => import("@/views/Pages/Profile/TailanReports.vue"),

      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/paymentmonitoring",
      name: "PaymentMonitoring",
      component: () => import("@/views/Pages/Profile/PaymentMonitoring.vue"),

      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/pagexeelj",
      name: "PageXEelj",
      component: PageXEelj,
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/studentsscorechecking25",
      name: "Unelgee125",
      component: () => import("@/views/Pages/Scores/Unelgee125.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/teachingplan",
      name: "TeachingPlan",
      component: () => import("@/views/Pages/Teachers/TeachingPlan.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/informproblems",
      component: () => import("@/sms/InformProblems.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/studentsscorechecking2",
      name: "Unelgee2",
      component: () => import("@/views/Pages/Scores/Unelgee2.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/studentsscoreconfirming2/:zClassGroupRefPath",
      name: "Unelgee2Confirmations",
      component: () => import("@/views/Pages/Scores/Unelgee2Confirmations.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/studentsscoreconfirming25/:classGroupRefPath/:classGroupId/:selectedHalfYearId",
      name: "Unelgee25Confirmations",
      component: () =>
        import("@/views/Pages/Scores/Unelgee25Confirmations.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/unelgee25analytics",
      name: "Unelgee25AnalyticsManager",
      component: () =>
        import("@/views/Pages/Scores/Unelgee25AnalyticsManager.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/unelgee2managermonitoring",
      name: "Unelgee2ManagerMonitoring",
      component: () =>
        import("@/views/Pages/Scores/Unelgee2ManagerMonitoring.vue"),
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/requests",
      name: "PageRequests",
      component: PageRequests,
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/requeststeachers",
      name: "PageExcuseRequestsTeacher",
      component: () => import("@/sms/excuses/PageExcuseRequestsTeacher.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/schoolplans",
      name: "SchoolPlans",
      component: () => import("@/sms/SchoolPlans.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/pagerequeststabs",
      name: "PageExcuseTabs",
      component: () => import("@/sms/excuses/PageExcuseTabs.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/pagerequeststabsclassteacherN",
      name: "MyNClassesExcuseRequestMonitoring",
      component: () =>
        import("@/sms/excuses/MyNClassesExcuseRequestMonitoring.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/classstudentsirzconfirmation",
      name: "",
      component: () => import("@/sms/excuses/ClassStudentsIrzConfirmation.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/managerexcusetabs",
      name: "ManagerExcuseTabs",
      component: () => import("@/sms/excuses/ManagerExcuseTabs.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },

    {
      path: "/pages/pages/scoringdaalgavar",
      name: "PageDaalgavar",
      component: PageDaalgavar,
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/scoringdaalgavarclassgroup/:classGroupPath/:daalgavarPath",
      name: "ScoringDaalgavar",
      component: () => import("@/sms/daalgavar/ScoringDaalgavar.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/scoringexam/:classGroupPath/:examPath",
      name: "ScoringExam",
      component: () => import("@/sms/exams/ScoringExam.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    //admins
    {
      path: "/pages/dashboards/implementationmonitoring2",
      name: "ImplementationMonitoring2",
      component: () =>
        import("@/sms/admins/monitoring/ImplementationMonitoring2.vue"),
      meta: {
        groupName: "Dashboards",
        requiresAuth: true,
      },
    },
    {
      path: "/pages/dashboards/classlessons",
      name: "classlessons",
      component: () => import("@/sms/admins/monitoring/ClassLessons.vue"),
      meta: {
        groupName: "Dashboards",
        requiresAuth: true,
      },
    },
    {
      path: "/pages/dashboards/jijuuradmin",
      name: "JijuurTeacherHuvaarilalt",
      component: () => import("@/sms/admins/JijuurTeacherHuvaarilalt.vue"),
      meta: {
        groupName: "Dashboards",
        requiresAuth: true,
      },
    },
    {
      path: "/pages/dashboards/FinalYearClosingPage",
      name: "FinalYearClosingPage",
      component: () => import("@/sms/admins/FinalYearClosingPage.vue"),
      meta: {
        groupName: "Dashboards",
        requiresAuth: true,
      },
    },
    {
      path: "/pages/dashboards/FinalYearClosingPageTeacher",
      name: "FinalYearClosingPageTeacher",
      component: () => import("@/sms/admins/FinalYearClosingPageTeacher.vue"),
      meta: {
        groupName: "Dashboards",
        requiresAuth: true,
      },
    },
    {
      path: "/asuulga",
      name: "Asuulga",
      component: () => import("@/views/Dashboard/PageAsuulga.vue"),
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/asuulga/editing/:asuulgaPath",
      name: "AsuulgaEditing",
      component: () => import("@/sms/asuulga/AsuulgaEditing.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/asuulga/results/:sorilId",
      name: "AsuulgaResults",
      component: () => import("@/sms/asuulga/AsuulgaResults.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/asuulga/asuulgaresultsmanagerpergroup/:sorilId",
      name: "AsuulgaResultsManagerPerGroup",
      component: () =>
        import("@/sms/asuulga/AsuulgaResultsManagerPerGroup.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/asuulga/resultsmanager/:sorilId",
      name: "AsuulgaResultsManager",
      component: () => import("@/sms/asuulga/AsuulgaResultsManager.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },

    {
      path: "/asuulga/resultsclassteacher/:sorilId",
      name: "AsuulgaResultsClassTeacher",
      component: () => import("@/sms/asuulga/AsuulgaResultsClassTeacher.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/asuulga/resultsteacher/",
      name: "AsuulgaResultsTeacher",
      component: () => import("@/sms/asuulga/AsuulgaResultsTeacher.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },

    {
      path: "/asuulga/teachers/:sorilId",
      name: "AsuulgaTeachers",
      component: () => import("@/sms/asuulga/AsuulgaTeachers.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/asuulga/asuulgacxAnswer/:sorilId",
      name: "AsuulgaCXAnswer",
      component: () => import("@/sms/asuulga/AsuulgaCXAnswer.vue"),
      props: true,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/studentshowassignmentallresults/:sorilId/:maxNumber",
      name: "StudentShowAssignmentAllResults",
      component: StudentShowAssignmentAllResults,
      meta: {
        groupName: "Pages",
      },
      props: true,
    },

    // {
    // 	path: '/asuulga/asuulgaanswering/:asuulgaRefPath/:bulegId/:teacherName/:teacherRefPath/:teacherLessons',
    // 	name: 'AsuulgaAnswering',
    // 	props: true,
    // 	component: () => import("@/sms/asuulga/AsuulgaAnswering"),
    // },
    {
      path: "/asuulga/asuulgaanswering/:asuulgaRefPath",
      name: "AsuulgaAnswering",
      props: true,
      component: () => import("@/sms/asuulga/AsuulgaAnswering"),
    },
    //togsolt devshilt
    {
      path: "/pages/dashboards/studentgrades",
      name: "StudentGrades",
      component: () => import("@/sms/devshilt_togsolt/StudentGrades.vue"),
      meta: {
        groupName: "Dashboards",
        requiresAuth: true,
      },
    },
  ],
};

let myClassPages = {
  path: "/myclass",
  component: DashboardLayout,
  name: "MyClass",
  children: [
    {
      path: "mynclassesunelgee2",
      name: "",
      component: MyNClassesUnelgee2,
      meta: {
        groupName: "MyClass",
        requiresAuth: true,
      },
    },
    {
      path: "mynclasseslessons25",
      name: "MyNClassesLessons25",
      component: () => import("@/bs/MyClass/MyNClassesLessons25.vue"),
      meta: {
        groupName: "MyClass",
        requiresAuth: true,
      },
    },
    {
      path: "mynclasseslessonssongolt",
      name: "MyNClassesLessons",
      component: MyNClassesLessonsSongolt,
      meta: {
        groupName: "MyClass",
        requiresAuth: true,
      },
    },
    {
      path: "mynclassescalendars",
      name: "MyNClassesCalendars",
      component: MyNClassesCalendars,
      meta: {
        groupName: "MyClass",
        requiresAuth: true,
      },
    },
  ],
};

let cooking = {
  path: "/cooking",
  component: DashboardLayout,
  name: "CookingProducts",
  children: [
    {
      path: "cookingproducts",
      name: "CookingProducts",
      component: () => import("@/cooking/CookingProducts"),
      meta: {
        groupName: "Cooking",
        requiresAuth: true,
      },
    },
    {
      path: "pos",
      name: "Pos",
      component: () => import("@/cooking/Pos.vue"),
      props: true,
      meta: {
        groupName: "Cooking",
        requiresAuth: true,
      },
    },
    {
      path: "cookinghistory",
      name: "CookingHistory",
      component: () => import("@/cooking/CookingHistory.vue"),
      props: true,
      meta: {
        groupName: "Cooking",
        requiresAuth: true,
      },
    },
    {
      path: "cookinganalysis",
      name: "CookingAnalysis",
      component: () => import("@/cooking/CookingAnalysis.vue"),
      props: true,
      meta: {
        groupName: "Cooking",
        requiresAuth: true,
      },
    },

    {
      path: "cookingproviders",
      name: "cookingproviders",
      component: () => import("@/cooking/CookingProviders.vue"),
      props: true,
      meta: {
        groupName: "Cooking",
        requiresAuth: true,
      },
    },

    {
      path: "cookingbuyproducts",
      name: "CookingBuyProducts",
      component: () => import("@/cooking/CookingBuyProducts.vue"),
      props: true,
      meta: {
        groupName: "Cooking",
        requiresAuth: true,
      },
    },

    {
      path: "cookingpageproblemregister",
      name: "CookingProblemRegister",
      component: () => import("@/cooking/CookingProblemRegister.vue"),
      props: true,
      meta: {
        groupName: "Cooking",
        requiresAuth: true,
      },
    },

    {
      path: "cookinghuvaari2",
      name: "CookingHuvaari2",
      component: () => import("@/cooking/CookingHuvaari2.vue"),
      props: true,
      meta: {
        groupName: "Cooking",
        requiresAuth: true,
      },
    },
    {
      path: "cookingingredients/:foodId",
      name: "CookingIngredients",
      component: () => import("@/cooking/CookingIngredients.vue"),
      props: true,
      meta: {
        groupName: "Cooking",
        requiresAuth: true,
      },
    },
    {
      path: "cookingsettings",
      name: "CookingSettings",
      component: () => import("@/cooking/CookingSettings.vue"),
      props: true,
      meta: {
        groupName: "Cooking",
        requiresAuth: true,
      },
    },
  ],
};

let cookingv2 = {
  path: "/cookingv2",
  component: DashboardLayout,
  name: "CookingV2",
  children: [
    {
      path: "home",
      name: "CookingV2Home",
      component: () => import("@/cookingv2/pages/cookingv2_home.vue"),
      meta: {
        groupName: "CookingV2",
        requiresAuth: true,
      },
    },
    {
      path: "materials",
      name: "CookingV2Materials",
      component: () => import("@/cookingv2/pages/cookingv2_materials.vue"),
      meta: {
        groupName: "CookingV2",
        requiresAuth: true,
      },
    },
    {
      // Superadmin-only central catalogue (materials/dishes every school
      // shares). Route sits under cookingv2 because it is the same module,
      // one level above a school.
      path: "catalog",
      name: "CookingV2Catalog",
      component: () => import("@/cookingv2/pages/cookingv2_catalog_admin.vue"),
      meta: {
        groupName: "CookingV2",
        requiresAuth: true,
      },
    },
    {
      // NEW catalogue-backed materials screen, live alongside the old tab.
      path: "materials-v2",
      name: "CookingV2MaterialsV2",
      component: () => import("@/cookingv2/pages/cookingv2_materials_v2.vue"),
      meta: {
        groupName: "CookingV2",
        requiresAuth: true,
      },
    },
    {
      // NEW catalogue-backed products screen, live alongside the old one so
      // both can be compared before anything is switched over.
      path: "products-v2",
      name: "CookingV2ProductsV2",
      component: () => import("@/cookingv2/pages/cookingv2_products_v2.vue"),
      meta: {
        groupName: "CookingV2",
        requiresAuth: true,
      },
    },
    {
      path: "products",
      name: "CookingV2Products",
      component: () => import("@/cookingv2/pages/cookingv2_products.vue"),
      meta: {
        groupName: "CookingV2",
        requiresAuth: true,
      },
    },
    {
      path: "purchases",
      name: "CookingV2Purchases",
      component: () => import("@/cookingv2/pages/cookingv2_purchases.vue"),
      meta: {
        groupName: "CookingV2",
        requiresAuth: true,
      },
    },
    {
      path: "daily-menus",
      name: "CookingV2DailyMenus",
      component: () => import("@/cookingv2/pages/cookingv2_daily_menus.vue"),
      meta: {
        groupName: "CookingV2",
        requiresAuth: true,
      },
    },
    {
      path: "studentmenu",
      name: "CookingV2StudentMenu",
      component: () => import("@/cookingv2/pages/cookingv2_student_menu.vue"),
      meta: {
        groupName: "CookingV2",
        requiresAuth: true,
      },
    },
    {
      path: "warehouse",
      name: "CookingV2Warehouse",
      component: () => import("@/cookingv2/pages/cookingv2_warehouse.vue"),
      meta: {
        groupName: "CookingV2",
        requiresAuth: true,
      },
    },
    {
      path: "reports",
      name: "CookingV2Reports",
      // Nutrition reports. The cost side lives in the warehouse now, where
      // the money it counts actually moves.
      component: () => import("@/cookingv2/pages/cookingv2_food_reports.vue"),
      meta: {
        groupName: "CookingV2",
        requiresAuth: true,
      },
    },
    {
      path: "teacher-meals",
      name: "CookingV2TeacherMeals",
      component: () => import("@/cookingv2/pages/cookingv2_teacher_meals.vue"),
      meta: {
        groupName: "CookingV2",
        requiresAuth: true,
      },
    },
    {
      path: "settings",
      name: "CookingV2Settings",
      component: () => import("@/cookingv2/pages/cookingv2_settings.vue"),
      meta: {
        groupName: "CookingV2",
        requiresAuth: true,
      },
    },
  ],
};

const fb = require("@/firebaseConfig.js");

const routers = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    authBasicPages,
    userPages,
    OrganizationSetting,
    myClassPages,
    cooking,
    cookingv2,
    libraryRoute,
    {
      path: "/homepage",
      name: "HomePage",
      component: () => import("@/views/HomePage.vue"),
    },
    {
      path: "/privacy.policy",
      name: "PrivacyPolicy",
      component: () => import("@/views/PrivacyPolicy.vue"),
      meta: {
        requiresAuth: false,
      },
    }, //do not delete
    {
      path: "/",
      name: "Dashboard",
      redirect: fb.COOKING_APP ? "/homepage" : "/pages/dashboards/default",
      component: DashboardLayout,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/pages/dashboards/default",
          name: "Default",
          component: Dashboard,
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },

        //for managers
        {
          path: "/pages/dashboards/lesson/:path",
          name: "PageLesson",
          component: PageLesson,
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        {
          path: "/pages/dashboards/lessonesis/:path",
          name: "PageLessonESIS",
          component: PageLessonESIS,
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        {
          path: "/pages/dashboards/lessonscores/:path",
          name: "PageLessonScores",
          component: () => import("@/views/Dashboard/PageLessonScores.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        {
          path: "/pages/dashboards/lessonesis/:path",
          name: "PageLessonESISSongon",
          component: () => import("@/views/Dashboard/PageLessonESISSongon.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        {
          path: "/pages/dashboards/lesson/homeworks/:path",
          name: "StudentsHomeWorksWidget",
          component: () =>
            import("@/views/Dashboard/Widgets/StudentsHomeWorksWidget.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        {
          path: "/pages/dashboards/allattendanceanalysis",
          name: "AllAttendanceAnalysis",
          component: () =>
            import("@/views/Pages/Irz/AllAttendanceAnalysis.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },

        {
          path: "/pages/dashboards/teacherlessonattendancetable",
          name: "TeacherLessonAttendanceTable",
          component: () =>
            import("@/views/Pages/Irz/TeacherLessonAttendanceTable.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/teacherlessononlinetable",
          name: "TeacherLessonOnlineTable",
          component: () =>
            import("@/views/Pages/Irz/TeacherOnlineLessonAttendanceTable.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/archive",
          name: "Archive",
          component: () => import("@/views/Pages/Archive/ArchivePage.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/songonlessons",
          name: "SongonLessons",
          component: () => import("@/sms/manager/SongonLessons.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/additionallessons",
          name: "AdditionalLessons",
          component: () => import("@/sms/manager/AdditionalLessons.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/onlineclasses",
          name: "Onlineclasses",
          component: () => import("@/views/Dashboard/OnlineClasses.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },

        {
          path: "/pages/dashboards/PageLessonPreview/:path",
          name: "PageLessonPreview",
          component: PageLessonPreview,
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },

        {
          path: "/pages/dashboards/specialassignments",
          name: "SpecialAssignments",
          component: () =>
            import("@/views/Pages/Assignments/SpecialAssignments.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/schoolhomeworkdatabase25",
          name: "SchoolHomeworkDatabase25",
          component: () =>
            import("@/views/Pages/Assignments/SchoolHomeworkDatabase25.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/Aichat",
          name: "Aichat",
          component: () => import("@/views/Pages/Assignments/Aichat.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/myassignments",
          name: "MyAssignments",
          component: () =>
            import("@/views/Pages/Assignments/MyAssignments.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/specialanalysis",
          name: "SpecialAnalysis",
          component: () => import("@/views/Pages/Analyzes/SpecialAnalysis.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/studenteyeshspecialanalysis",
          name: "StudentEyeshSpecialAnalysis",
          component: () =>
            import("@/views/Pages/Analyzes/StudentEyeshSpecialAnalysis.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/schoolassignments",
          name: "SchoolAssignments",
          component: () =>
            import("@/views/Pages/Assignments/SchoolAssignments.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/allassignments",
          name: "AllAssignments",
          component: () =>
            import("@/views/Pages/Assignments/AllAssignments.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/AssignmentDatabaseDevshilt",
          name: "AllAssignments",
          component: () =>
            import("@/views/Pages/Assignments/AssignmentDatabaseDevshilt.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/teachersoril",
          name: "",
          component: () => import("@/views/Pages/Teachers/TeacherSoril.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/eyesh800sorils",
          name: "",
          component: () => import("@/views/Pages/Teachers/Eyesh800Sorils.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },

        {
          path: "/pages/dashboards/pagesorilassignmentsbygrandit",
          name: "PageSorilAssignmentsByGrandit",
          component: PageSorilAssignmentsByGrandit,
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/questionanalysis",
          name: "QuestionAnalysis",
          component: () =>
            import("@/views/Pages/Assignments/QuestionAnalysis.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/studentssorils",
          name: "StudentsSorils",
          component: StudentsSorils,
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/studentssorils800",
          name: "StudentsSorils800",
          component: () =>
            import("@/views/Pages/Students/StudentsSorils800.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/studentssorilsofschools2",
          name: "StudentsSorilsOfSchools2",
          component: () =>
            import("@/views/Pages/Students/StudentsSorilsOfSchools2.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/studentssorilsofcity",
          name: "StudentsSorilsOfCity",
          component: () =>
            import("@/views/Pages/Students/StudentsSorilsOfCity.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/studentsindexedsorils",
          name: "StudentsIndexedSorils",
          component: () =>
            import("@/views/Pages/Students/StudentsIndexedSorils.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/studentlessondetail/:path",
          name: "StudentLessonDetail",
          component: StudentLessonDetail,
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        {
          path: "/pages/dashboards/studentselectlessons",
          name: "StudentSelectLessons",
          component: StudentSelectLessons,
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        {
          path: "/pages/dashboards/studentcalendary",
          name: "StudentCalendary",
          component: () =>
            import("@/views/Pages/Students/StudentCalendary.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        {
          path: "/pages/dashboards/studentkindergartenirz",
          name: "StudentKinderGartenIrz",
          component: () =>
            import("@/views/Pages/Students/StudentKinderGartenIrz.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        {
          path: "/pages/dashboards/studentunelgee1",
          name: "",
          component: () => import("@/views/Pages/Scores/Unelgee1Students.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        {
          path: "/pages/dashboards/studentunelgee125",
          name: "",
          component: () =>
            import("@/views/Pages/Scores/Unelgee125Students.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        {
          path: "/pages/dashboards/studentunelgee25",
          name: "",
          component: () => import("@/views/Pages/Scores/Unelgee25Students.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        {
          path: "/pages/dashboards/studentslesson",
          name: "StudentsLesson",
          component: () => import("@/views/Pages/Students/StudentsLesson.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        {
          path: "/pages/dashboards/studentshowassignmentresults/:sorilId",
          name: "StudentShowAssignmentResults",
          component: StudentShowAssignmentResults,
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },

        {
          path: "/pages/dashboards/studentshowassignmentallresultsdetail/:sorilId",
          name: "StudentShowAssignmentAllResultsDetail",
          component: StudentShowAssignmentAllResultsDetail,
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        {
          path: "/pages/dashboards/assignmentsettings",
          name: "AssignmentSettings",
          component: () =>
            import("@/views/Pages/Assignments/AssignmentSettings.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/assignmentschoolsettings",
          name: "AssignmentSchoolSettings",
          component: () =>
            import("@/views/Pages/Assignments/AssignmentSchoolSettings.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/allquestionsanalysis/:asuulga/:numberOfQuestions",
          name: "AllQuestionsAnalysis",
          component: AllQuestionsAnalysis,
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        {
          path: "/pages/dashboards/reportschool/:results/:asuulga",
          name: "ReportSchool",
          component: ReportSchool,
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },

        {
          path: "/pages/dashboards/eyeshmongoladmin/",
          name: "EyeshMongolAdmin",
          component: () => import("@/bs/eyesh/EyeshMongolAdmin.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        {
          path: "/pages/dashboards/eyeshmongolhelstudent/",
          name: "EyeshMongolHelStudent",
          component: () => import("@/bs/eyesh/EyeshMongolHelStudent.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },

        {
          path: "/pages/dashboards/studentlessonchart/",
          name: "StudentLessonChart",
          component: () => import("@/views/Charts/StudentLessonChart.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
          props: true,
        },
        //citymanager
        {
          path: "/pages/studenthomework",
          name: "StudentHomework",
          component: () => import("@/homework/pages/homework_student.vue"),
          meta: {
            groupName: "Pages",
            requiresAuth: true,
          },
        },
        {
          path: "/citymanager/food",
          name: "CityFood",
          component: () => import("@/citymanager/CityFood.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/dashboards/cityassignments",
          name: "CityAssignments",
          component: () =>
            import("@/views/Pages/Assignments/CityAssignments.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },

        {
          path: "/pages/dashboards/AssignmentsForTeachers",
          name: "AssignmentsForTeachers",
          component: () =>
            import("@/views/Pages/Assignments/AssignmentsForTeachers.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },

        {
          path: "/pages/dashboards/cityassignmentsgu",
          name: "CityAssignmentsGuizetgelUnelgee",
          component: () =>
            import(
              "@/views/Pages/Assignments/CityAssignmentsGuizetgelUnelgee.vue"
            ),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/parents/dailyirz",
          name: "ParentsDailyIrz",
          props: true,
          component: () => import("@/views/Pages/Irz/ParentsDailyIrz.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/parents/parentsstudentslessons",
          name: "ParentsStudentsLessons",
          props: true,
          component: () =>
            import("@/views/Pages/Irz/ParentsStudentsLessons.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
        {
          path: "/pages/parents/paymenttable",
          name: "ParentsPaymentTable",
          props: true,
          component: () => import("@/views/Pages/Irz/ParentsPaymentTable.vue"),
          meta: {
            groupName: "Dashboards",
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "/shalgaltediting/:xpath",
      name: "XShalgaltEditing",
      props: true,
      component: () => import("@/views/Pages/Assignments/XShalgaltEditing"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/shalgalteditingeyesh/:xpath/:fromEYESH",
      name: "XShalgaltEditingEyesh",
      props: true,
      component: () =>
        import("@/views/Pages/Assignments/XShalgaltEditingEyesh"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/questionediting/:xpath",
      name: "XQuestionEditing",
      props: true,
      component: () => import("@/views/Pages/Assignments/XQuestionEditing"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/shalgaltvieweyesh/:xpath",
      name: "XShalgaltViewEyesh",
      props: true,
      component: () => import("@/views/Pages/Assignments/XShalgaltViewEyesh"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      // Нийлүүлэгчид зориулсан ЗӨВХӨН УНШИХ захиалга. Нэвтрэлт шаардахгүй —
      // нийлүүлэгч системийн хэрэглэгч биш, доорх examShare-тэй ижил зам.
      // Сургууль/захиалгын id холбоос дотор байгаа тул хуудас шууд баримт
      // руу очно (цуглуулгын бүлгийн индекс нэхэхгүй), баримт дээрх
      // shareToken таарч байж л агуулгаа харуулна.
      path: "/orderShare/:schoolId/:purchaseId/:token",
      name: "CookingV2OrderShare",
      props: true,
      component: () => import("@/cookingv2/pages/cookingv2_order_share.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/examShare/:sharedLink",
      name: "XShalgaltEditingEyeshPublic",
      props: true,
      component: () =>
        import("@/views/Pages/Assignments/XShalgaltEditingEyeshPublic"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/examShare/:folder/:linkId",
      redirect: (to) => ({
        path: `/examShare/${to.params.folder}%2F${to.params.linkId}`,
        query: to.query,
      }),
    },
    {
      path: "/examEditShare/:sharedLink",
      name: "XShalgaltEditingEyeshShared",
      props: true,
      component: () =>
        import("@/views/Pages/Assignments/XShalgaltEditingEyesh"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/examEditShare/:folder/:linkId",
      redirect: (to) => ({
        path: `/examEditShare/${to.params.folder}%2F${to.params.linkId}`,
        query: to.query,
      }),
    },
    {
      path: "/shalgaltsharing/:shalgaltIdd",
      name: "XShalgaltSharing",
      props: true,
      component: () => import("@/views/Pages/Assignments/XShalgaltSharing"),
    },
    {
      path: "/xshalgalteyeshsharingoutside/:shalgaltIdd",
      name: "XShalgaltEyeshSharingOutside",
      props: true,
      component: () =>
        import("@/views/Pages/Assignments/XShalgaltEyeshSharingOutside"),
      meta: {
        requiresAuth: false,
      },
    },

    {
      path: "/xshalgalteyeshsharing/:shalgaltIdd:/:fromEYESH",
      name: "XShalgaltEyeshSharing",
      props: true,
      component: () =>
        import("@/views/Pages/Assignments/XShalgaltEyeshSharing"),
    },
    {
      path: "/shalgaltresults/:item",
      name: "XShalgaltResults",
      props: true,
      component: () => import("@/views/Pages/Assignments/XShalgaltResults"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/publicstudentsscore/:sorilId",
      name: "PublicStudentsScore",
      component: PublicStudentsScore,
      props: true,
    },
    {
      path: "/pages/dashboards/studentshowassignmentallresults2/:sorilId",
      name: "StudentShowAssignmentAllResults2",
      component: () =>
        import("@/views/Pages/Assignments/XShowAssignmentAllResults2.vue"),
      meta: {
        requiresAuth: false,
      },
      props: true,
    },

    {
      path: "/pages/dashboards/studentshowassignmentresultspublic/:sorilId",
      name: "StudentShowAssignmentResultsPublic",
      component: () =>
        import("@/views/Pages/Students/StudentShowAssignmentResultsPublic.vue"),
      props: true,
    },
    {
      path: "/une/:shalgaltIdd",
      name: "UnelgeeAnswering",
      props: true,
      component: () => import("@/unelgee/UnelgeeAnswering"),
    },
    {
      path: "/UnelgeeResults/:item",
      name: "UnelgeeResults",
      props: true,
      component: () => import("@/unelgee/UnelgeeResults"),
      meta: {
        requiresAuth: true,
      },
    },
  ],
  linkActiveClass: "active", // active class for non-exact links.
  linkExactActiveClass: "active",
});

import { store } from "@/store.js";
routers.beforeEach(async (to, from, next) => {
  if (
    store &&
    store.state &&
    store.state.userData &&
    store.state.userData.ref
  ) {
    store.state.userData.ref.update({
      lastLoggedAt: new Date(),
    });
  }

  const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);
  const allowedRoles = to.matched.reduce(
    (roles, route) => route.meta.allowedRoles || roles,
    null,
  );
  // const requiresPermissionCheck = to.matched.some(x => x.meta.requiresPermissionCheck);

  if (to.matched[1]) {
    const xpath = to.matched[1].path;
    store.state.xRouterLink = xpath;
  }
  const systemLocked = false;

  if (requiresAuth && store.state.userData) {
    if (store.state.userData) {
      if (allowedRoles && !allowedRoles.includes(store.state.userData.role)) {
        next({ path: "/pages/dashboards/default" });
        return;
      }
      if (systemLocked) {
        if (
          store.state.userData.role == "superadmin" ||
          store.state.userData.role == "student"
        ) {
          next();
        } else {
          next({
            name: "Login",
            // name: "LoginTeacher", //25219
          });
        }
      } else {
        next();
      }
    } else if (store.state.mendleUserRef) {
      next();
    } else {
      next({
        name: "Login",
        // name: "LoginTeacher", //25219
      });
    }
  } else if (requiresAuth && !store.state.userData) {
    next({
      name: "Login",
      // name: "LoginTeacher", //25219
    });
  } else {
    next();
  }
});

// A lazily loaded page can fail to arrive — a slow network times the chunk
// out, or a deploy removed the file the cached index.html asks for. Either way
// the router stops and the screen stays blank, so reload once and carry on.
routers.onError((error) => {
  const failed = /Loading chunk .* failed|ChunkLoadError/i.test(
    error?.message || "",
  );
  if (!failed) return;

  const stamp = "chunkReloadedAt";
  try {
    if (window.sessionStorage.getItem(stamp)) return;
    window.sessionStorage.setItem(stamp, String(Date.now()));
  } catch (e) {
    // No storage — reloading once without the guard is still better than a
    // blank page.
  }
  window.location.reload();
});

export default routers;
